<template>
    <AppHeader fixed>
        <SidebarToggler class="d-lg-none" display="md" mobile />
        <b-link class="navbar-brand" to="#">
            <img class="navbar-brand-full" :src="$logoPath+'?2023-11-28'" @error.once="$event.target.src = '/img/pgi-logo.png'" height="40" alt="PGI Logo">
            <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
        </b-link>
  
            <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
            <span v-if="$store.state.readNotifstore.readCount != 0" class="badge" style="
                position: relative;
                top: -7px;
                right: 4px;
                padding: 0px 4px;
                border-radius: 100%;
                background: red;
                color: white;
            "> &nbsp; {{ $store.state.readNotifstore.readCount }}</span>
        <!-- <div class="ml-2 header-user-cabang">
            <span class="mb-0">Cabang</span>
            <strong> Daan Mogot </strong>
        </div> -->
        <div class="desktop-last-login">
            <span style="font-size: 12px;">Last Login</span><br>
            <span style="font-size: 12px;"> {{ lastLogin }}</span>
        </div>
        <!-- <b-navbar-nav class="d-md-down-none">
            <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        </b-navbar-nav> -->
        <b-navbar-nav class="ml-auto">
            <b-nav-item class="header-user-info">
            <div class="header-user-data">
                <h6 class="header-user-name">
                    {{ name }}
                    <span class="header-user-setting ml-1" v-b-tooltip.hover title="Change Password" @click="$bvModal.show('modal-change-password')">
                        <i class="fa fa-cog"></i>
                    </span>
                </h6>
                <div class="d-flex align-items-center justify-content-end mt-1">
                    <span class="header-user-position">{{ role }}</span> 
                    <span class="ml-1 mr-1">-</span>
                    <CabangOption className="header-small-dropdown" @gadaiEmasActive="gadaiEmasActive" @cabangChanged="cabangChanged" />
                </div>
            </div>
            </b-nav-item>
            <b-nav-item class="header-notif-link" @click="openNotif">
                <i class="fa fa-bell"></i>
                <b-badge v-if="totalNotif > 0" pill variant="danger" class="header-notif-badge">{{totalNotif}}</b-badge>
            </b-nav-item>
            <b-nav-item class="header-logout-link" @click="logout">
                <i class="fa fa-power-off" /><span>Log Out</span>
            </b-nav-item>
            <ModalConfirm id="modal-confirm-logout" title="Confirm Logout" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk logout?" @submit="onSubmit" />
        </b-navbar-nav>
        <b-modal id="modal-change-password" title="Ubah Password" no-close-on-esc no-close-on-backdrop :hide-header-close="isSubmitting">
            <b-form id="changePasswordForm" @submit.prevent="openModalConfirmChangePwd">
                <div class="modal-form-wrapper">
                    <b-form-group label="Password Lama" class="password-form-group">
                        <b-form-input v-model="input.oldPassword" name="oldPassword" :type="oldPasswordType" required></b-form-input>
                        <i :class="oldIconName" @click="changePasswordType(1)" ></i>
                    </b-form-group>
                    <b-form-group label="Password Baru" class="password-form-group">
                        <b-form-input v-model="input.newPassword" name="newPassword" :type="newPasswordType" minlength=6 required></b-form-input>
                        <i :class="newIconName" @click="changePasswordType(2)" ></i>
                    </b-form-group>
                    <b-form-group label="Ketik Ulang Password Baru" class="password-form-group">
                        <b-form-input v-model="input.confirmPassword" name="confirmPassword" :type="confirmPasswordType" minlength=6 required></b-form-input>
                        <i :class="confirmIconName" @click="changePasswordType(3)" ></i>
                    </b-form-group>
                </div>
                <!-- <div class="login-error-wrapper mt-3" v-if="errorMessage != ''">
                    <div class="text-danger">{{ errorMessage }}</div>
                </div> -->
            </b-form>
            <template v-slot:modal-footer>
                <b-button variant="pgiBtn" name="changePasswordBtn" type="submit" form="changePasswordForm" :disabled="isSubmitting">
                    {{ isSubmitting ? "Mengubah..." : "Ubah Password" }}
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="modal-confirm-editPwd" title="Confirm Change Password" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah password anda?" @submit="doChangePassword" />
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import CabangOption from '../components/cabang/CabangOption'

export default {
    name: 'DefaultHeader',
    components: {
        AsideToggler,
        AppHeader,
        // DefaultHeaderDropdownAccnt,
        SidebarToggler,
        CabangOption
    },
    props: {
        // hasNotification: { type: Boolean, required: true }
        totalNotif: { type: Number, required: true}
    },
    data() {
        return {
            isSubmitting: false,
            name: localStorage.getItem("name"),
            role: localStorage.getItem("role"),
            cabang: localStorage.getItem("activeCabang"),
            lastLogin: localStorage.getItem("lastLogin"),
            input:{
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            errorMessage: "",

            oldPasswordType: 'password',
            oldIconName: 'fa fa-eye-slash',
            newPasswordType: 'password',
            newIconName: 'fa fa-eye-slash',
            confirmPasswordType: 'password',
            confirmIconName: 'fa fa-eye-slash',
        }
    }, 
 
    methods: {
        getUnreadCount() {
            this.$axios.get('informasi-umum/count-unreads')
            .then(response => {
                this.$store.state.readNotifstore.readCount = response.data.id
            })
            .catch(error => {
            console.error(error)
            })
        },
        gadaiEmasActive(index){
            this.$emit('gadaiEmasActive' ,index)
        },
        cabangChanged(){
            this.$emit('cabangChanged')
        },
        logout() {
            this.$bvModal.show("modal-confirm-logout")
        },
        onSubmit() {
            this.$emit("did-logout")
        },
        openNotif() {
            this.$emit("did-tap-notification")
            this.$router.push("/dashboard")
        },

        doChangePassword() {

            let payload = new FormData()
            payload.append("oldPassword", this.input.oldPassword)
            payload.append("newPassword", this.input.newPassword)
            payload.append("repeatNewPassword", this.input.confirmPassword)

            this.isSubmitting = true
            this.$axios.post("user/selfChangePassword/", payload).then(() => {

                this.input.oldPassword = ""
                this.input.newPassword = ""
                this.input.confirmPassword = ""
                this.oldPasswordType= 'password'
                this.oldIconName= 'fa fa-eye-slash'
                this.newPasswordType= 'password'
                this.newIconName= 'fa fa-eye-slash'
                this.confirmPasswordType= 'password'
                this.confirmIconName= 'fa fa-eye-slash'
                this.$helper.toastSucc(this, "Password berhasil diubah, silahkan login kembali!")
                this.$bvModal.hide("modal-confirm-editPwd")
                this.$bvModal.hide("modal-change-password")
            })
            .catch(error => {
                // this.$helper.parseError(this, error)
                // this.errorMessage = error.response.data.reason
                this.$helper.toastErr(this, error.response.data.reason)
                this.$bvModal.hide("modal-confirm-editPwd")
                
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },
        //----------------- Fungsi Lain -----------------

        openModalConfirmChangePwd(){
            this.$bvModal.show("modal-confirm-editPwd")
        },

        changePasswordType(id) {
            if(id == 1){
                if(this.oldPasswordType == 'password' && this.oldIconName == 'fa fa-eye-slash') {
                    this.oldPasswordType = 'text'
                    this.oldIconName = 'fa fa-eye'
                }
                else {
                    this.oldPasswordType = 'password'
                    this.oldIconName = 'fa fa-eye-slash'
                }
            }else if(id == 2){
                if(this.newPasswordType == 'password' && this.newIconName == 'fa fa-eye-slash') {
                    this.newPasswordType = 'text'
                    this.newIconName = 'fa fa-eye'
                }
                else {
                    this.newPasswordType = 'password'
                    this.newIconName = 'fa fa-eye-slash'
                }
            }else{
                if(this.confirmPasswordType == 'password' && this.confirmIconName == 'fa fa-eye-slash') {
                    this.confirmPasswordType = 'text'
                    this.confirmIconName = 'fa fa-eye'
                }
                else {
                    this.confirmPasswordType = 'password'
                    this.confirmIconName = 'fa fa-eye-slash'
                }
            }
        },
    },
}
</script>
